import React, { useMemo } from 'react';
import {
  StyledTable,
  StandardAreaInstallationTableRow
} from 'modules';
import { useParams } from 'react-router-dom';
import * as ds from './dataService';

export type StandardAreaInstallationTableProps = {};

export const FC = (props: StandardAreaInstallationTableProps) => {
  const params = useParams();

  const { data } = ds.useQuery();

  const headers: string[] = [
    'Selection Name',
    'Area',
    'Sub Area',
    'Type',
    'Associated Milestone',
    ''
  ];

  const rows = useMemo(() => {
    return data.map((node, i) => (
      <StandardAreaInstallationTableRow.FC
        key={i}
        {...node}
      />
    ));
  }, [data]);

  return (
    <StyledTable.FC
      headers={headers}
      rows={rows}
    />

  );
};
